import { getAlertRuleDetailInfo } from "api/alertAPI";

import { useAppSelector } from "redux/hooks";
import { useQuery } from "react-query";
import {
  AlertRuleDetailInfoResponse,
  AlertRuleListResponse,
} from "api/interfaces/alertInterface.interface";
import AddRuleContainer from "../add/AddRuleContainer";
import useApiError from "hook/useApiError";

interface Props {
  onModal: (type?: string) => void;
  isEdit?: boolean;
  isView?: boolean;
  alertRule?: AlertRuleListResponse;
}

function EditRuleContainer(props: Props): JSX.Element {
  const selectedAccount = useAppSelector((state) => state.accountSettings);
  const { lang, notifyError } = useApiError();

  const alertRuleId: string = props.alertRule?.alertRuleId ?? "";
  const accountId = selectedAccount.accountId;

  const { data: editData } = useQuery(
    ["alertRuleDetailInfo", alertRuleId, accountId],
    () =>
      getAlertRuleDetailInfo({
        accountId,
        alertRuleId,
      }),
    {
      enabled: Boolean(alertRuleId),
      retry: 0,
      refetchOnWindowFocus: false,
      select: (res: AlertRuleDetailInfoResponse) => {
        if (res.error === 0 && res.result) {
          return res.result;
        }
        throw new Error(res.errorString || "ALERT_RULE_DETAIL_FAIL");
      },
      onError: () => {
        notifyError(lang.label.alertRule.notify.getDetail.fail);
      },
    }
  );

  if (!editData) {
    return <></>;
  }

  return (
    <AddRuleContainer
      isEdit={props.isEdit}
      isView={props.isView}
      editData={editData}
      alertRule={props.alertRule}
      onModal={() => props.onModal("edit")}
    />
  );
}

export default EditRuleContainer;
